// @flow
import { useFormContext } from 'react-hook-form';

import { useTranslator } from '@gandi/translate';

import { TextField } from 'src/Reshaped/Form/TextField';

export function SubscriptionNameField(): React.MixedElement | null {
  const { __ } = useTranslator();

  const form = useFormContext();

  return (
    <TextField
      name="name"
      label={__('Subscription name')}
      control={form.control}
      rules={{ required: __('This field is required') }}
      inputProps={{
        placeholder: __(
          'Internal name to identify this pack in your interface',
        ),
        variant: 'faded',
      }}
      // $FlowFixMe[incompatible-type]]
      inputAttributes={{
        required: true,
        style: {
          marginBottom: 'var(--rs-unit-x1)',
        },
      }}
      size="large"
    />
  );
}
